require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./project-dubai-hotel.json") })
        }
      }, "path---project-dubai-hotel");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---project-dubai-hotel!./.cache/json/project-dubai-hotel.json
// module id = 568
// module chunks = 231608221292675